@import (reference) '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.smart-fill-icon {
  margin-left: @space-4;
  height: 12px;
  cursor: pointer;
}

.smart-fill-tooltip {
  cursor: pointer;
}
